/** Category dialog rules (TO-416 product-admin-ui REQ-008). */
export interface CategoryFormValues {
	code: string
	name: string
	icon: string
	/** Raw text; empty means 0. */
	sortOrder: string
}

export const EMPTY_CATEGORY_FORM: CategoryFormValues = { code: '', name: '', icon: '', sortOrder: '' }

const CODE_RE = /^[a-z0-9][a-z0-9-]*$/

const sortOrderOk = (text: string): boolean => {
	if (text === '') return true
	if (!/^\d+$/.test(text)) return false
	return Number(text) <= 10000
}

/** Client-side errors keyed by field; empty when the dialog may be sent. */
export const categoryErrors = (values: CategoryFormValues): Record<string, string> => {
	const errors: Record<string, string> = {}
	if (values.code.length > 64 || !CODE_RE.test(values.code)) errors.code = 'categories.errors.code'
	if (values.name.trim() === '' || values.name.length > 255) errors.name = 'categories.errors.name'
	if (values.icon.length > 64) errors.icon = 'categories.errors.icon'
	if (!sortOrderOk(values.sortOrder)) errors.sortOrder = 'categories.errors.sortOrder'
	return errors
}

export const toCategoryBody = (values: CategoryFormValues) => ({
	code: values.code,
	name: values.name,
	icon: values.icon === '' ? null : values.icon,
	sortOrder: values.sortOrder === '' ? 0 : Number(values.sortOrder),
})
